import { tagInfo } from '@mollusk/shared';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { MONO } from '../theme';

/** A tag, in mono, with its definition on hover; links to the tag in the data
 *  dictionary (#171: "Tag chips anywhere on the site"). */
export function TagChip({ tag, count }: { tag: string; count?: number }) {
  const info = tagInfo(tag);
  const chip = (
    <Chip
      component="a"
      href={`/data-dictionary?tab=tags&tag=${encodeURIComponent(tag)}`}
      clickable
      size="small"
      variant="outlined"
      label={count == null ? tag : `${tag} ${count.toLocaleString()}`}
      onClick={(e) => e.stopPropagation()}
      sx={{ fontFamily: MONO, fontSize: 12, height: 22 }}
      aria-label={tag}
    />
  );
  return info ? (
    <Tooltip title={`${tag}: ${info.description}`} arrow describeChild>
      {chip}
    </Tooltip>
  ) : (
    chip
  );
}
